import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Avatar, Icon } from '../ui/index.js';
import { useAuth } from '../lib/auth.js';

/** The avatar button in the nav, with a small menu that includes sign out. */
export function AccountMenu() {
  const { me, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    const onPointerDown = (e: PointerEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  if (!me) return null;

  const onLogout = async () => {
    setOpen(false);
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="pt-accountmenu" ref={ref}>
      <button
        type="button"
        className="pt-iconbtn"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Your account"
        onClick={() => setOpen((v) => !v)}
      >
        <Avatar name={me.name} size={32} />
      </button>
      {open ? (
        <div className="pt-accountmenu__panel" role="menu">
          <div className="pt-accountmenu__head">
            <Avatar name={me.name} size={40} />
            <div>
              <div className="pt-accountmenu__name">{me.name}</div>
              <div className="pt-accountmenu__handle">@{me.username}</div>
              <div className="pt-accountmenu__role">{me.role}</div>
            </div>
          </div>
          <button type="button" className="pt-menuitem" role="menuitem" onClick={onLogout}>
            <Icon name="logout" size={18} />
            Log out
          </button>
        </div>
      ) : null}
    </div>
  );
}
